
import { createTheme } from '@mui/material';
import { faIR } from '@mui/material/locale';
const theme = createTheme(
	{
		direction: 'rtl',
		typography: {
			fontFamily: 'IRANSans',
			fontSize: 14,
		},
		palette: {
			primary: {
				// light: '#ec8f2a',
				light: '#dc7200',
				main: '#F18B39',
				dark: '#dc7200',
				contrastText: '#fff',
			},
			secondary: {
				light: '#3c2f40',
				main: '#1f1921',
				dark: '#161218',
				contrastText: '#000',
			},
			success: {
				main: '#1d8802',
			},
		},
		faIR
	},
	
);

export default theme;

